import { Avatar, Carousel, Dropdown, Image, MenuProps } from 'antd';
import classNames from 'classnames';
import { checkUserMentioned, parsedChatMessages } from 'helpers/getLinkedTextArray';
import { IChatMessage } from 'interfaces';
import React from 'react';
import classes from './Messages.module.scss';
import { TFunction } from 'i18next';
import fallbackHolder from 'assets/img/fallback.png';

type RecieveMessageProps = {
  date: string;
  isTagsDisabled: boolean;
  chatMessage: IChatMessage;
  contextMenu: (message: IChatMessage) => MenuProps['items'];
  replyOn: (chatMessage: IChatMessage, isRecieve: boolean) => JSX.Element;
  t: TFunction;
  onTagClick: (event: any) => void;
  currentUserEmail?: string;
  replyHandle: (message: IChatMessage) => void;
  aiAssistant?: boolean;
};

const RecieveMessage: React.FC<RecieveMessageProps> = ({
  date,
  isTagsDisabled,
  chatMessage,
  contextMenu,
  replyOn,
  t,
  onTagClick,
  currentUserEmail,
  replyHandle,
  aiAssistant,
}) => {
  const isMentioned = currentUserEmail ? checkUserMentioned(chatMessage.message, currentUserEmail) : false;
  
  return (
    <Dropdown
      classNames={{ root: classes.dropdown }}
      menu={{ items: contextMenu(chatMessage) }}
      trigger={['contextMenu']}
    >
      <div className={classes.recieveWrapper}>
        <div
          id={chatMessage.id}
          className={classNames(
            classes.recieve,
            classes.first,
            isMentioned && classes.mentionedMessage,
            { [classes.aiType]: aiAssistant }
          )}
        >
          {!aiAssistant && <Avatar size={34} className={classes.avatar}>
            <span className={classes.avatarWord}>
              {chatMessage.user_name
                .split(/\s+/)
                .map((t) => t[0])
                .join('')}
            </span>
          </Avatar>}

          <div>
            <div className={classNames(classes.recieveMessage, classes.first)}>

              <div className={classes.author}>
                <div>{chatMessage.user_name}</div>
                <div onClick={() => replyHandle(chatMessage)} className={classes.replyBtn}>{t('Chats.reply')}</div>
              </div>

              {chatMessage.replied_to && replyOn(chatMessage, true)}

              <div className={classes.messageText}>
                {Boolean(chatMessage.attachment_ids?.length) && (
                  <div style={{ position: 'relative' }}>
                    <Image.PreviewGroup preview={{ countRender: (current, total) => null }}>
                      <Carousel style={{ width: '250px', overflow: 'hidden' }}>
                        {chatMessage?.attachment_ids!.map((id, index) => (
                          <Image
                            src={id}
                            fallback={fallbackHolder}
                            key={`Image-${index}`}
                            alt='Attachment'
                            classNames={{ root: classes.attachment_img }}
                          />
                        ))}
                      </Carousel>
                    </Image.PreviewGroup>
                  </div>
                )}
                {parsedChatMessages(
                  chatMessage.message,
                  { className: classes.messageTag, disabled: isTagsDisabled, onClick: onTagClick },
                  isTagsDisabled ? t('Documents.table.noPermissionToView') : undefined,
                  classes.urlLink,
                  classes.userMessageTag
                )}
              </div>
              <div className={classes.timeElemRecieve}>{date}</div>
            </div>

          </div>
        </div>
      </div>
    </Dropdown>
  );
};

export default RecieveMessage;
